import type { ReactNode } from 'react';
import { Section } from '@vnetwork/ui/layout';
import { Card, CardBody } from '@vnetwork/ui/primitives';
import { EmptyState } from '@vnetwork/ui/data';

interface TabStubProps {
  title: string;
  description: string;
  /** Short note on what this tab will configure (content-layout marker). */
  note?: ReactNode;
  icon?: ReactNode;
}

/**
 * Content-layout placeholder for a domain tab that is scaffolded but not yet
 * ported. Renders the same section chrome (title + description) the real tab
 * will use, so navigation and layout are wired ahead of the implementation.
 */
export function TabStub({ title, description, note, icon }: TabStubProps) {
  return (
    <Section title={title} description={description}>
      <Card>
        <CardBody>
          <EmptyState
            icon={icon}
            title={`${title} — not built yet`}
            description={note ?? 'This tab is scaffolded — its full UI lands in a later pass.'}
          />
        </CardBody>
      </Card>
    </Section>
  );
}
